import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'

import { RoutesRecognized } from '@angular/router'

@Component({
    template: `<router-outlet></router-outlet>`
})
export class InternalComponent implements OnInit {
    prevUrl: string

    constructor(private router: Router) {
        //this.router.events
        //    .filter(e => e instanceof RoutesRecognized)
        //    .pairwise()
        //    .subscribe((event: any[]) => {
        //        this.prevUrl = event[0].urlAfterRedirects
        //        console.log(event[0].urlAfterRedirects)
        //    });
    }

    ngOnInit(): void {
        let currentRoute = this.currentUrl()
        console.log('Current Route: ' + currentRoute)
        //let Url = 'enrollment'
        //if (this.prevUrl !== undefined) {
        //    //do Noothing
        //    if (this.prevUrl.indexOf(Url) > -1) {
        //        // this.router.navigateByUrl('/home')
        //    }
        //    else
        //        this.router.navigateByUrl('/home')
        //}
        //else if (localStorage.getItem('showlicense') === null) {
        //    this.router.navigateByUrl('/home')
        //}
    }

    currentUrl(): string {
        var url: string
        url = location.href
        return url
    }
}
